import React from 'react'
import { useNavigate } from 'react-router-dom'

import config from '../../../config'
import { formatDateShort } from '../../../lib/dates'
import { useAuth } from '../../../context/auth'
import { Invoice, InvoiceStatus } from '../../../types'
import Amount from '../../ui/currency/amount'
import StatusBadge from '../statusBadge'
import { ReactComponent as MoneyIcon } from '../../../static/images/money.svg'

import './styles.scss'

type Props = {
  invoice: Invoice
  isActive?: boolean
}

const InvoiceStackedCard: React.FC<Props> = ({ invoice, isActive = false }) => {
  const navigate = useNavigate()
  const { user } = useAuth()

  const handleCardClick = () => {
    if (invoice._id) {
      navigate(`/invoices/${invoice._id}`)
    }
  }

  const handlePdfClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (invoice._id) {
      window.open(`${config.REACT_APP_API_URL}/api/invoices/pdf/${String(invoice._id)}`, '_blank')
    }
  }

  return (
    <div
      className={['invoice-stacked-card', isActive ? 'invoice-stacked-card--active' : ''].filter(Boolean).join(' ')}
      onClick={handleCardClick}
      role='button'
      tabIndex={0}
      aria-current={isActive ? 'true' : undefined}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleCardClick()
        }
      }}
    >
      <button
        type='button'
        className='invoice-stacked-card__pdf'
        onClick={handlePdfClick}
        aria-label={`View PDF for invoice ${invoice.code ?? ''}`}
      >
        <MoneyIcon />
      </button>
      <div className='invoice-stacked-card__body'>
        <div className='invoice-stacked-card__row invoice-stacked-card__row--top'>
          <span className='invoice-stacked-card__date'>
            {formatDateShort(invoice.issueDate, user?.locale)}
          </span>
          <span className='invoice-stacked-card__code'>{invoice.code}</span>
          <span className='invoice-stacked-card__amount'>
            <Amount
              value={invoice.total as number}
              currencySymbol={invoice?.businessDetails?.currency?.symbol}
            />
          </span>
        </div>
        <div className='invoice-stacked-card__row invoice-stacked-card__row--bottom'>
          <StatusBadge status={(invoice.status as InvoiceStatus)} size='sm' />
          <span className='invoice-stacked-card__client'>{invoice.client?.tradingName ?? '—'}</span>
        </div>
      </div>
    </div>
  )
}

export default InvoiceStackedCard
